export default class YandexMap {
    constructor(idMap, inputId) {
        (this.id = idMap), (this.input = inputId), (this.coord = "");
    }

    run() {
        var instance = this;

        if (!$("#" + instance.id).length) {
            return;
        }
        ymaps.ready(init);


        function init() {
            var myPlacemark,
                myMap = new ymaps.Map(
                    instance.id, {
                        center: [59.939095, 30.315868],
                        zoom: 9,
                    }, {
                        searchControlProvider: "yandex#search",
                    }
                );

            // Слушаем клик на карте.
            myMap.events.add("click", function(e) {
                var coords = e.get("coords");

                // Если метка уже создана – просто передвигаем ее.
                if (myPlacemark) {
                    myPlacemark.geometry.setCoordinates(coords);
                }
                // Если нет – создаем.
                else {
                    myPlacemark = createPlacemark(coords);
                    myMap.geoObjects.add(myPlacemark);
                    // Слушаем событие окончания перетаскивания на метке.
                    myPlacemark.events.add("dragend", function() {
                        getAddress(myPlacemark.geometry.getCoordinates());
                    });
                }
                getAddress(coords);
            });

            // Создание метки.
            function createPlacemark(coords) {
                return new ymaps.Placemark(
                    coords, {
                        iconCaption: "поиск...",
                    }, {
                        preset: "islands#violetDotIconWithCaption",
                        draggable: true,
                    }
                );
            }

            // Определяем адрес по координатам (обратное геокодирование).
            function getAddress(coords) {
                instance.coord = coords;
                document.getElementById("coords").value = coords;
                myPlacemark.properties.set("iconCaption", "поиск...");
                ymaps.geocode(coords).then(function(res) {
                    var firstGeoObject = res.geoObjects.get(0);
                    let inputAddres = document.getElementById(instance.input);
                    inputAddres.innerHTML = firstGeoObject.getAddressLine();

                    myPlacemark.properties.set({
                        // Формируем строку с данными об объекте.
                        iconCaption: [
                                // Название населенного пункта или вышестоящее административно-территориальное образование.
                                firstGeoObject.getLocalities().length ?
                                firstGeoObject.getLocalities() :
                                firstGeoObject.getAdministrativeAreas(),
                                // Получаем путь до топонима, если метод вернул null, запрашиваем наименование здания.
                                firstGeoObject.getThoroughfare() || firstGeoObject.getPremise(),
                            ]
                            .filter(Boolean)
                            .join(", "),
                        // В качестве контента балуна задаем строку с адресом объекта.
                        balloonContent: firstGeoObject.getAddressLine(),
                    });
                });
            }
        }
    }
}

(function($) {

    let map = new YandexMap("event-map-edit", "addres");

    if ($("#event-map-edit").length) {
        map.run();
    }

})(jQuery);